import request from '@/utils/request'

// 操作日志API

// 分页查询操作日志列表
export function listLogs(params) {
  return request({
    url: '/api/admin/system/logs',
    method: 'get',
    params
  })
}

// 获取操作日志详情
export function getLog(logId) {
  return request({
    url: `/api/admin/system/logs/${logId}`,
    method: 'get'
  })
}

// 获取操作日志统计数据
export function getLogStatistics(params) {
  return request({
    url: '/api/admin/system/logs/statistics',
    method: 'get',
    params
  })
}

// 导出操作日志
export function exportLogs(data) {
  return request({
    url: '/api/admin/system/logs/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
